import { randomString } from '@fabric-app/utils/random';

const createStyledClone = (node, deep = true) => {
  if (!(node instanceof Element)) {
    return node.cloneNode(deep);
  }
  const clone = node.cloneNode(deep);
  const originalNodes = [
    node
  ];
  const clonedNodes = [
    clone
  ];
  if (deep) {
    originalNodes.push(...node.querySelectorAll("*"));
    clonedNodes.push(...clone.querySelectorAll("*"));
  }
  originalNodes.forEach((originalNode, index) => {
    if (!(originalNode instanceof HTMLElement) || !(clonedNodes[index] instanceof HTMLElement)) return;
    const clonedNode = clonedNodes[index];
    const styles = window.getComputedStyle(originalNode);
    const propertiesToSkip = [
      "grid",
      "pointer-events"
    ];
    const counterProperties = [
      "counter-reset",
      "counter-increment"
    ];
    counterProperties.forEach((prop) => {
      const value = styles.getPropertyValue(prop);
      if (value && value !== "none") {
        clonedNode.style.setProperty(prop, value);
      }
    });
    Array.from(styles).forEach((property) => {
      if (propertiesToSkip.includes(property)) {
        return;
      }
      clonedNode.style.setProperty(property, styles.getPropertyValue(property));
    });
    const pseudoElements = [
      "::before",
      "::after"
    ];
    pseudoElements.forEach((pseudo) => {
      const pseudoStyles = window.getComputedStyle(originalNode, pseudo);
      const content = pseudoStyles.getPropertyValue("content");
      if (content && content !== "none" && content !== "normal") {
        const styleElement = document.createElement("style");
        styleElement.setAttribute("data-for-clone", `${clonedNode.tagName.toLowerCase()}-${pseudo}`);
        clonedNode.appendChild(styleElement);
        if (!clonedNode.id) {
          clonedNode.id = `cloned-element-${Date.now()}-${randomString(10)}`;
        }
        let cssText = `#${clonedNode.id}${pseudo} {`;
        cssText += `content: ${content};`;
        Array.from(pseudoStyles).forEach((property) => {
          if (!propertiesToSkip.includes(property) && property !== "content") {
            cssText += `${property}: ${pseudoStyles.getPropertyValue(property)};`;
          }
        });
        cssText += "}";
        styleElement.textContent += cssText;
      }
    });
  });
  return clone;
};

export { createStyledClone };
//# sourceMappingURL=createStyledClone.js.map
